import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { convertStringMatcherConditions } from 'src/actions/rules/condition';
import generateId from 'src/lib/generateId';

export function useOnSave({ add, isNew, item, resetErrors, setComplete, update, validateRule, workingState }) {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(resetErrors());

    const draft = workingState.toJs();
    if (!dispatch(validateRule(draft))) return;

    convertStringMatcherConditions(draft.conditions);

    setComplete(true);
    if (isNew) {
      dispatch(add({}, { id: generateId(), ...draft }));
    } else {
      draft._version = draft._version + 1;
      dispatch(update({ id: item.id }, draft));
    }
  }, [add, dispatch, isNew, item, resetErrors, setComplete, update, validateRule, workingState]);
}
